import { create } from "zustand";

/**
 * Intent dispatch request published by components that live outside the schema
 * renderer tree (e.g. the avatar menu). The shell subscribes and runs the intent.
 * The `nonce` makes repeated dispatches of the same intent observable.
 */
export interface PendingIntent {
  intent: string;
  loadingText?: string;
  nonce: number;
}

interface UIStore {
  /** True when the PWA install banner is visible at the bottom of the screen */
  isPwaBannerVisible: boolean;
  setPwaBannerVisible: (visible: boolean) => void;
  /** A one-shot intent request for the schema shell to dispatch. */
  pendingIntent: PendingIntent | null;
  requestIntent: (intent: string, loadingText?: string) => void;
  clearPendingIntent: () => void;
}

export const useUIStore = create<UIStore>((set, get) => ({
  isPwaBannerVisible: false,
  setPwaBannerVisible: (visible) => set({ isPwaBannerVisible: visible }),
  pendingIntent: null,
  requestIntent: (intent, loadingText) =>
    set({ pendingIntent: { intent, loadingText, nonce: (get().pendingIntent?.nonce ?? 0) + 1 } }),
  clearPendingIntent: () => set({ pendingIntent: null }),
}));
